module.exports = {
    
    // baseUrl : "http://localhost:3837/api/v1/",
    baseUrl : "https://quercusoakstays-com-backend.onrender.com/api/v1/",
    backendIP : "https://quercusoakstays-com-backend.onrender.com",
    // backendIP : "http://localhost:3837",
    frontendURL : "https://quercusoakstays.com",
    // frontendURL : "http://localhost:3000/",
    AXIOS_APIKEY : '68e3bfe2bc127e61cc01e2e3f3f029704b0a',   
    SUCCESS:200,
    MARQUEE_COUNT:12,
    TIME_SAVING_COUNT:80,
    REVENUE_GROWTH_COUNT:30,
    STAFF_EFFICIENCY_COUNT:60,
    GUEST_SATISFACTION_COUNT:100,
    OPERATION_VISIBILITY_COUNT:100,
    GUEST_FEEDBACK_COUNT:75,
    TRUSTEDBY_COUNT:50,
    EMAIL_REGEX:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    NEWS_LETTER:"newsletter",
    NON_STEALTH_ROUTE:"",
    COMPANY_FACEBOOK_HANDLE_URL:"",
    COMPANY_LINKEDIN_HANDLE_URL:"",
    COMPANY_INSTAGRAM_HANDLE_URL:"",
    COMPANY_YOUTUBE_HANDLE_URL:"",
    COMPANY_X_HANDLE_URL:"",
    COMPANY_DISCORD_HANDLE_URL:"",
    BOOK_DEMO_URL : "",
    DEBUG_LOG : false,
    COMPANY_PHONE : "919119772488",
    WHATSAPP_CHAT_NUMBER : "919119772488",
    WHATSAPP_LIST_MESSAGE : "Hello! I'm interested in inquiring about Hosting my property with you. Please let me know the best way to proceed. Thanks!",
    WHATSAPP_CHAT_MESSAGE : "Hello! I'm interested in inquiring about a stay at one of your properties. Please let me know the best way to proceed with a booking. Thanks!",
    COMPANY_NAME:"Quercus Oak Hospitality Private Limited",
    COMPANY_ADDRESS:"Pakki Dhaang, Naag Mandir Road, Mussoorie, Dehradun, Uttarakhand - 248179",
    RESRVATION_ADDRESS:"Khasra no 369, Raipur, Dehradun, Uttarakhand - 248008",
    RESRVATION_PHONE : "917078950757",
    COMPANY_EMAIL: "connect@querusoakstays.com",
    COMPANY_INFO: "Quercus Oak Stays is a tradename of Quercus Oak Hospitality Pvt. Ltd., a Company Registered in India under the Companies Act 2013.",
    

}


         
   
      

    
    
      

      


    

